/**
 * Well-known element IDs used across multiple files.
 * Add IDs here when they're referenced in 3+ places.
 * For one-off IDs, inline strings are fine.
 */

// ── Preact mount points ─────────────────────────────────────
// These containers are managed by Preact. Do NOT manipulate
// their innerHTML via jQuery or vanilla JS after mount.
export const PREACT_MOUNT_POINTS = new Set([
  "modals",
  "download-cart-target",
  "mockup-target",
  "metadataqueue",
  "itopsearch-results",
  // Dynamic: "artwork-{id}", "modal_{id}" — not listed here
] as const);

// ── Layout / Chrome ──────────────────────────────────────────
export const ID_SCROLL_TO_TOP = "scroll-to-top";
export const ID_AUTORESIZE = "autoresize";
export const ID_WINDOW_SIDEBAR = "window-sidebar";
export const ID_MODALS = "modals";
export const ID_COLLECTION_BUTTONS = "collection-buttons";
export const ID_COLLECTION_BUTTONS_TITLE = "collection-buttons-title";
export const ID_SELECT_POPUP = "select-popup";

// ── Infinite scroll state (hidden inputs) ────────────────────
export const ID_LM_ACTIVE = "lm_active";
export const ID_LM_MODE = "lm_mode";
export const ID_LM_TARGET = "lm_target";

// ── Search ───────────────────────────────────────────────────
export const ID_ITOPSEARCH_TARGET = "itopsearch-target";
export const ID_ITOPSEARCH_HEADER = "itopsearch-header";

// ── Cart / Downloads ─────────────────────────────────────────
export const ID_DOWNLOAD_CART_TARGET = "download-cart-target";
export const ID_DOWNLOAD_CART_COUNT = "download-cart-count";

/**
 * Dev-mode check: warn if vanilla JS is about to mutate a Preact container.
 * Call this in getDomElement/getDomElementOrThrow during development
 * to catch accidental Preact state corruption.
 */
export function warnIfPreactManaged(id: string, operation: string): void {
  if (
    location.hostname === "localhost" &&
    PREACT_MOUNT_POINTS.has(id as typeof PREACT_MOUNT_POINTS extends Set<infer T> ? T : never)
  ) {
    console.warn(
      `[DOM] "${operation}" on #${id} — this is a Preact mount point. ` +
        `Direct DOM manipulation may corrupt Preact state.`
    );
  }
}
